import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

import { ActivityMatterRatesService } from '../../../services/activity_matter_rates/activity-matter-rates.service';
import { NotyService } from '../../../services/common/noty.service';
import { HttpClientService } from '../../../services/common/http-client.service';
import { UserService } from '../../../services/users/user.service';

@Component({
  selector: 'app-activity-matter-rates-index',
  templateUrl: './activity-matter-rates-index.component.html',
  styleUrls: ['./activity-matter-rates-index.component.css']
})
export class ActivityMatterRatesIndexComponent implements OnInit, OnDestroy {
  sidebarMaximized: boolean = true;
  sidebarOpen: boolean = false;
  componentDestroyed: boolean = false;
  sidebarScrollTimeouts: Array<any> = [];

  constructor(private activityMatterRatesService: ActivityMatterRatesService,
    private httpClientService: HttpClientService,
    private notyService: NotyService,
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,)
  { }

  count: number = 0;

  downloadCsvUrl: string = "";

  searchParams: any = {
    page: 1,
    per_page: 50,
  };

  searching: boolean = false;

  searchOptions: any = {};

  activityMatterRates: Array<any> = [];

  ngOnInit(): void {
    this.initialize();
  }

  ngAfterViewInit() {
    this.sidebarScrollTimeouts.push(setTimeout(() => {
      if(this.componentDestroyed) return;
      this.content_sidebar_scroll();
    }, 500));
    this.sidebarScrollTimeouts.push(setTimeout(() => {
      if(this.componentDestroyed) return;
      this.content_sidebar_scroll();
    }, 5000));
  }

  ngOnDestroy(): void {
    this.componentDestroyed = true;
    this.sidebarScrollTimeouts.forEach(timeout => clearTimeout(timeout));
  }

  clearSearch() {
    if(this.componentDestroyed) return;
    this.router.navigate(['.'], { relativeTo: this.route, queryParams: {} });
    this.resetParams();
    this.search();
  }

  initialize() {
    if(this.componentDestroyed) return Promise.resolve();
    this.resetParams();
    Object.assign(this.searchParams, this.route.snapshot.queryParams);
    return this.activityMatterRatesService.getSearchOptions().then(response_json =>{
      if(this.componentDestroyed) return;
      console.log("search options activity matter rates index", response_json);
      this.searchOptions = response_json;
      if(this.searchOptions && this.searchOptions.per_page)
        this.searchParams.per_page = this.searchOptions.per_page;
      this.search(null, true);
    }).catch(getSearchOptionsFail=>{
      if(this.componentDestroyed) return;
      console.log("search options errors", getSearchOptionsFail);
    });
  }

  resetParams() {
    this.searchParams = {
      page: 1,
      per_page: 50,
      commit: "search",
      search_activity_matter_rates: true
    }
  }

  search(pageEvent: any = null, isSearching: boolean | null = false) {
    if(this.componentDestroyed) return Promise.resolve();
    console.log("search params", this.searchParams);
    if (isSearching)
      this.searching = true;
    return this.activityMatterRatesService.index(this.searchParams).then(response_json => {
      if(this.componentDestroyed) return;
      let count = 0;
      console.log("activity matter rates array with count", count++, response_json);
      if (isSearching)
        this.searching = false;
      this.activityMatterRates = response_json.activity_matter_rates
      this.count = response_json.count
      let newPageUrl: string = this.httpClientService.buildNewPageUrl(this.activityMatterRatesService.url, this.searchParams);
      this.downloadCsvUrl = newPageUrl.replace("commit=search", "commit=Download%20CSV").replace("activity_matter_rates?", "activity_matter_rates.csv?");
      if(window.location.href != newPageUrl)
        this.httpClientService.setNewPageUrl(newPageUrl);
    }).catch(searchErr =>{
      if(this.componentDestroyed) return;
      console.log("search error", searchErr);
      this.searching = false;
      this.notyService.notify('Error loading activity matter rates', 'error');
    })
  }

  delete(id: number) {
    if(this.componentDestroyed) return Promise.resolve();
    console.log("id from activity matter rates component:", id)
    if(id){
      return this.activityMatterRatesService.delete(id).then(deleteRe=>{
        if(this.componentDestroyed) return;
        console.log("deleteRe", deleteRe)
        this.notyService.notify('successfully deleted', 'success');
        this.search(null, true)
      }).catch(deleteError=>{
        if(this.componentDestroyed) return;
        console.log("deleteError", deleteError)
        this.notyService.notify('Error deleting', 'error');
      })
    }
    else{
      console.log("id not recieved")
      return Promise.resolve();
    }
  }

  @HostListener('window:scroll', ['$event'])
  window_scroll(event: Event) {
    this.content_sidebar_scroll();
  }

  @HostListener('window:resize', ['$event'])
  window_resize(event: Event) {
    this.content_sidebar_scroll();
  }

  content_sidebar_scroll() {
    if(this.componentDestroyed) return;
    var content_main = document.getElementById('content-main');
    var content_sidebar = document.getElementById('content-sidebar');
    var sidebar_height = window.innerHeight;
    if (content_sidebar && content_main) {
      if (content_main.getBoundingClientRect().top > 19) {
        content_sidebar.style.position = 'absolute';
        content_sidebar.style.top = content_main.offsetTop + 'px';
        sidebar_height -= content_main.getBoundingClientRect().top + 20;
      } else {
        content_sidebar.style.position = 'fixed';
        content_sidebar.style.top = '20px';
        sidebar_height -= content_sidebar.getBoundingClientRect().top + 20;
      }

      if (content_sidebar.clientHeight != sidebar_height) content_sidebar.style.height = sidebar_height + 'px';
    }
  }
}
